import { gql } from './gql'

/**
 * The brands a filter can offer.
 *
 * cinnamon asks for brands and categories in one `GetFiltersValues` document.
 * Here the categories already arrive through `GET_CATEGORIES` — the chips need
 * them at boot, before any filter UI is opened — so asking a second time would
 * give the storefront two sources for one list. This is the half that had no
 * other home.
 *
 * `brands` is not session-scoped: the list is the storefront's, and narrowing
 * it to what this customer can buy is what `search`'s `filter.brands` does when
 * one is picked.
 */
export const GET_BRANDS = gql`
  query GetBrands($storefrontName: String!, $pagination: PaginationInput) {
    brands(storefrontName: $storefrontName, pagination: $pagination) {
      name
    }
  }
`
